<template>
  <div>
    <div>
      <div class="joinHeader">
        <div>
          <h1>세이프가드 해지</h1>
        </div>
      </div>
    </div>
    <div>
      <div class="topBox">
        <div class="textBox">
          <p>
            안전한 금융거래를 위해서
            <br />
            <b style="color: #2cbbb6 !important;">세이프가드</b>를
            <br />
            <strong>계속 이용해 보세요 !</strong>
          </p>
        </div>

        <div class="imgBox">
          <div class="svgBox">
            <img src="@/assets/img/i_mobile_KT.png" alt />
          </div>
        </div>
      </div>
    </div>
    <cancel-form></cancel-form>
    <footer-component></footer-component>
  </div>
</template>

<script>
import FooterComponent from "@/components/FooterComponentKT.vue";
import CancelForm from "@/components/Join/CancelFormKT.vue";

export default {
  data() {
    return {
      mainTitle: "세이프가드 해지"
    };
  },
  components: {
    CancelForm,
    FooterComponent
  }
};
</script>
<style src="@/assets/css/extWeb/common.css"></style>
<style src="@/assets/css/extWeb/join.css"></style>
<style src="@/assets/css/extWeb/pass.css"></style>
<style scoped>
.joinHeader {
  height: 50px;
  background-color: #fff;
  border-bottom: 1px solid #000;
}
.joinHeader div {
  text-align: center;
  line-height: 44px;
}
.joinHeader h1 {
  display: inline-block;
  font-size: 16px;
  color: #000;
  vertical-align: middle;
  line-height: normal;
}
.topBox {
  padding: 25px 18px 20px;
  position: relative;
  background-color: #f9f9f9;
}

.topBox p {
  font-size: 16px;
  color: #000;
  letter-spacing: -0.74px;
  /* line-height: 18px; */
  padding-bottom: 15px;
}
.topBox p b {
  color: #f34545;
  font-weight: normal;
}
/* .topBox p strong {
} */
.topBox .imgBox {
  position: absolute;
  right: 15%;
  bottom: 10%;
  width: 17%;
}
.topBox .imgBox img {
  width: 100%;
  max-width: 70px;
}
.topBox .imgBox .svgBox {
  max-width: 70px;
}
@media (min-width: 768px) {
  .topBox .imgBox {
    right: 2%;
  }
}
</style>
